import styled from 'styled-components'

export const AnimateScaleInInner = styled.span`
  display: block;
  height: 100%;
  left: 0;
  position: ${props => props.position};
  top: 0;
  width: 100%;
  z-index: 1;
`

export const AnimateScaleInWrapper = styled.span`
  border-radius: ${props => (props.borderRadius ? `0.6rem` : ``)};
  display: block;
  height: 100%;
  overflow: hidden;
  position: relative;
  pointer-events: ${props => props.pointer};
  transform-origin: 50% 50%;
  user-select: none;
  width: 100%;
  will-change: transform;
`
